export class StopAreaEditWouldMakeRouteInvalidError extends Error {}
